const init = (fn) => {
  if(typeof Turbo !== 'undefined') {
    document.addEventListener('turbo:load', fn);
  }
  else {
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn)
      : fn();
  }
};

export default init;
